// extracted by mini-css-extract-plugin
export default {"content":"DateWarningModal_content__t-A69"};